// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/icomoon.eot?qn1hwh", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/icomoon.ttf?qn1hwh", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/icomoon.woff?qn1hwh", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/icomoon.svg?qn1hwh", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'icomoon';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-earphone:before {
  content: "\\e963";
}
.icon-copy:before {
  content: "\\e962";
}
.icon-cloud:before {
  content: "\\e961";
}
.icon-ai-assist:before {
  content: "\\e960";
}
.icon-collapse:before {
  content: "\\e95f";
}
.icon-convert-text:before {
  content: "\\e95e";
}
.icon-import:before {
  content: "\\e95d";
}
.icon-loading:before {
  content: "\\e95c";
}
.icon-send:before {
  content: "\\e95b";
}
.icon-email:before {
  content: "\\e953";
}
.icon-backup:before {
  content: "\\e92b";
}
.icon-restore:before {
  content: "\\e92c";
}
.icon-desktop:before {
  content: "\\e959";
  color: #585858;
}
.icon-phone:before {
  content: "\\e95a";
  color: #585858;
}
.icon-github:before {
  content: "\\e90f";
  color: #585858;
}
.icon-onedrive:before {
  content: "\\e930";
  color: #585858;
}
.icon-facebook:before {
  content: "\\e931";
  color: #585858;
}
.icon-microsoft:before {
  content: "\\e952";
  color: #585858;
}
.icon-s3compatible:before {
  content: "\\e958";
}
.icon-feedback:before {
  content: "\\e957";
}
.icon-sftp:before {
  content: "\\e956";
}
.icon-ftp:before {
  content: "\\e954";
}
.icon-smb:before {
  content: "\\e955";
}
.icon-archive:before {
  content: "\\e951";
}
.icon-browser:before {
  content: "\\e950";
}
.icon-internet:before {
  content: "\\e94f";
}
.icon-dict:before {
  content: "\\e94e";
}
.icon-bookshelf-line:before {
  content: "\\e94b";
}
.icon-highlight-line:before {
  content: "\\e94c";
}
.icon-select:before {
  content: "\\e94d";
}
.icon-trash-line:before {
  content: "\\e943";
}
.icon-detail:before {
  content: "\\e944";
}
.icon-bookshelf:before {
  content: "\\e945";
}
.icon-edit-line:before {
  content: "\\e946";
}
.icon-address-book:before {
  content: "\\e947";
}
.icon-idea-line:before {
  content: "\\e948";
}
.icon-heart:before {
  content: "\\e949";
}
.icon-home-line:before {
  content: "\\e94a";
}
.icon-day:before {
  content: "\\e936";
}
.icon-eye:before {
  content: "\\e941";
}
.icon-night:before {
  content: "\\e942";
}
.icon-highlight:before {
  content: "\\e935";
}
.icon-check:before {
  content: "\\e922";
}
.icon-share:before {
  content: "\\e91c";
}
.icon-google:before {
  content: "\\e928";
}
.icon-speaker:before {
  content: "\\e929";
}
.icon-search-book:before {
  content: "\\e92f";
}
.icon-digest:before {
  content: "\\e927";
}
.icon-sort-desc:before {
  content: "\\e917";
}
.icon-sync:before {
  content: "\\e918";
}
.icon-folder:before {
  content: "\\e920";
}
.icon-menu:before {
  content: "\\e924";
}
.icon-minus:before {
  content: "\\e915";
}
.icon-cover:before {
  content: "\\e914";
}
.icon-lock:before {
  content: "\\e912";
}
.icon-unlock:before {
  content: "\\e913";
}
.icon-export:before {
  content: "\\e911";
}
.icon-zoom-in:before {
  content: "\\e908";
}
.icon-save:before {
  content: "\\e909";
}
.icon-zoom-out:before {
  content: "\\e90a";
}
.icon-clockwise:before {
  content: "\\e90c";
}
.icon-counterclockwise:before {
  content: "\\e90e";
}
.icon-scroll1:before {
  content: "\\e905";
}
.icon-setting:before {
  content: "\\e904";
}
.icon-audio:before {
  content: "\\e903";
}
.icon-scroll:before {
  content: "\\e902";
}
.icon-love:before {
  content: "\\e901";
}
.icon-trash:before {
  content: "\\e906";
}
.icon-edit:before {
  content: "\\e907";
}
.icon-translation:before {
  content: "\\e900";
}
.icon-english:before {
  content: "\\e92d";
}
.icon-simplified:before {
  content: "\\e92e";
  color: #565656;
}
.icon-traditional:before {
  content: "\\e932";
  color: #565656;
}
.icon-local:before {
  content: "\\e92a";
}
.icon-two-page:before {
  content: "\\e925";
}
.icon-single-page:before {
  content: "\\e926";
}
.icon-message:before {
  content: "\\e923";
}
.icon-close:before {
  content: "\\e921";
}
.icon-home:before {
  content: "\\e90b";
}
.icon-popup:before {
  content: "\\e91f";
}
.icon-note:before {
  content: "\\e91a";
}
.icon-collect:before {
  content: "\\e91b";
}
.icon-copy-line:before {
  content: "\\e91d";
}
.icon-success:before {
  content: "\\e91e";
}
.icon-add:before {
  content: "\\e90d";
}
.icon-dropbox:before {
  content: "\\e910";
  color: #4b4b4b;
}
.icon-webdav:before {
  content: "\\e916";
  color: #4b4b4b;
}
.icon-exit:before {
  content: "\\e919";
}
.icon-fullscreen:before {
  content: "\\e933";
}
.icon-googledrive:before {
  content: "\\e934";
  color: #4b4b4b;
}
.icon-list:before {
  content: "\\e937";
}
.icon-more:before {
  content: "\\e938";
}
.icon-bookmark:before {
  content: "\\e939";
}
.icon-shelf:before {
  content: "\\e93a";
}
.icon-idea:before {
  content: "\\e93b";
}
.icon-recent:before {
  content: "\\e93c";
}
.icon-sort:before {
  content: "\\e93d";
}
.icon-search:before {
  content: "\\e93e";
}
.icon-grid:before {
  content: "\\e93f";
}
.icon-dropdown:before {
  content: "\\e940";
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAAqC;EACrC;;;yDAGuD;EACvD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6BAAoB;EAApB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('fonts/icomoon.eot?qn1hwh');\n  src:  url('fonts/icomoon.eot?qn1hwh#iefix') format('embedded-opentype'),\n    url('fonts/icomoon.ttf?qn1hwh') format('truetype'),\n    url('fonts/icomoon.woff?qn1hwh') format('woff'),\n    url('fonts/icomoon.svg?qn1hwh#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-earphone:before {\n  content: \"\\e963\";\n}\n.icon-copy:before {\n  content: \"\\e962\";\n}\n.icon-cloud:before {\n  content: \"\\e961\";\n}\n.icon-ai-assist:before {\n  content: \"\\e960\";\n}\n.icon-collapse:before {\n  content: \"\\e95f\";\n}\n.icon-convert-text:before {\n  content: \"\\e95e\";\n}\n.icon-import:before {\n  content: \"\\e95d\";\n}\n.icon-loading:before {\n  content: \"\\e95c\";\n}\n.icon-send:before {\n  content: \"\\e95b\";\n}\n.icon-email:before {\n  content: \"\\e953\";\n}\n.icon-backup:before {\n  content: \"\\e92b\";\n}\n.icon-restore:before {\n  content: \"\\e92c\";\n}\n.icon-desktop:before {\n  content: \"\\e959\";\n  color: #585858;\n}\n.icon-phone:before {\n  content: \"\\e95a\";\n  color: #585858;\n}\n.icon-github:before {\n  content: \"\\e90f\";\n  color: #585858;\n}\n.icon-onedrive:before {\n  content: \"\\e930\";\n  color: #585858;\n}\n.icon-facebook:before {\n  content: \"\\e931\";\n  color: #585858;\n}\n.icon-microsoft:before {\n  content: \"\\e952\";\n  color: #585858;\n}\n.icon-s3compatible:before {\n  content: \"\\e958\";\n}\n.icon-feedback:before {\n  content: \"\\e957\";\n}\n.icon-sftp:before {\n  content: \"\\e956\";\n}\n.icon-ftp:before {\n  content: \"\\e954\";\n}\n.icon-smb:before {\n  content: \"\\e955\";\n}\n.icon-archive:before {\n  content: \"\\e951\";\n}\n.icon-browser:before {\n  content: \"\\e950\";\n}\n.icon-internet:before {\n  content: \"\\e94f\";\n}\n.icon-dict:before {\n  content: \"\\e94e\";\n}\n.icon-bookshelf-line:before {\n  content: \"\\e94b\";\n}\n.icon-highlight-line:before {\n  content: \"\\e94c\";\n}\n.icon-select:before {\n  content: \"\\e94d\";\n}\n.icon-trash-line:before {\n  content: \"\\e943\";\n}\n.icon-detail:before {\n  content: \"\\e944\";\n}\n.icon-bookshelf:before {\n  content: \"\\e945\";\n}\n.icon-edit-line:before {\n  content: \"\\e946\";\n}\n.icon-address-book:before {\n  content: \"\\e947\";\n}\n.icon-idea-line:before {\n  content: \"\\e948\";\n}\n.icon-heart:before {\n  content: \"\\e949\";\n}\n.icon-home-line:before {\n  content: \"\\e94a\";\n}\n.icon-day:before {\n  content: \"\\e936\";\n}\n.icon-eye:before {\n  content: \"\\e941\";\n}\n.icon-night:before {\n  content: \"\\e942\";\n}\n.icon-highlight:before {\n  content: \"\\e935\";\n}\n.icon-check:before {\n  content: \"\\e922\";\n}\n.icon-share:before {\n  content: \"\\e91c\";\n}\n.icon-google:before {\n  content: \"\\e928\";\n}\n.icon-speaker:before {\n  content: \"\\e929\";\n}\n.icon-search-book:before {\n  content: \"\\e92f\";\n}\n.icon-digest:before {\n  content: \"\\e927\";\n}\n.icon-sort-desc:before {\n  content: \"\\e917\";\n}\n.icon-sync:before {\n  content: \"\\e918\";\n}\n.icon-folder:before {\n  content: \"\\e920\";\n}\n.icon-menu:before {\n  content: \"\\e924\";\n}\n.icon-minus:before {\n  content: \"\\e915\";\n}\n.icon-cover:before {\n  content: \"\\e914\";\n}\n.icon-lock:before {\n  content: \"\\e912\";\n}\n.icon-unlock:before {\n  content: \"\\e913\";\n}\n.icon-export:before {\n  content: \"\\e911\";\n}\n.icon-zoom-in:before {\n  content: \"\\e908\";\n}\n.icon-save:before {\n  content: \"\\e909\";\n}\n.icon-zoom-out:before {\n  content: \"\\e90a\";\n}\n.icon-clockwise:before {\n  content: \"\\e90c\";\n}\n.icon-counterclockwise:before {\n  content: \"\\e90e\";\n}\n.icon-scroll1:before {\n  content: \"\\e905\";\n}\n.icon-setting:before {\n  content: \"\\e904\";\n}\n.icon-audio:before {\n  content: \"\\e903\";\n}\n.icon-scroll:before {\n  content: \"\\e902\";\n}\n.icon-love:before {\n  content: \"\\e901\";\n}\n.icon-trash:before {\n  content: \"\\e906\";\n}\n.icon-edit:before {\n  content: \"\\e907\";\n}\n.icon-translation:before {\n  content: \"\\e900\";\n}\n.icon-english:before {\n  content: \"\\e92d\";\n}\n.icon-simplified:before {\n  content: \"\\e92e\";\n  color: #565656;\n}\n.icon-traditional:before {\n  content: \"\\e932\";\n  color: #565656;\n}\n.icon-local:before {\n  content: \"\\e92a\";\n}\n.icon-two-page:before {\n  content: \"\\e925\";\n}\n.icon-single-page:before {\n  content: \"\\e926\";\n}\n.icon-message:before {\n  content: \"\\e923\";\n}\n.icon-close:before {\n  content: \"\\e921\";\n}\n.icon-home:before {\n  content: \"\\e90b\";\n}\n.icon-popup:before {\n  content: \"\\e91f\";\n}\n.icon-note:before {\n  content: \"\\e91a\";\n}\n.icon-collect:before {\n  content: \"\\e91b\";\n}\n.icon-copy-line:before {\n  content: \"\\e91d\";\n}\n.icon-success:before {\n  content: \"\\e91e\";\n}\n.icon-add:before {\n  content: \"\\e90d\";\n}\n.icon-dropbox:before {\n  content: \"\\e910\";\n  color: #4b4b4b;\n}\n.icon-webdav:before {\n  content: \"\\e916\";\n  color: #4b4b4b;\n}\n.icon-exit:before {\n  content: \"\\e919\";\n}\n.icon-fullscreen:before {\n  content: \"\\e933\";\n}\n.icon-googledrive:before {\n  content: \"\\e934\";\n  color: #4b4b4b;\n}\n.icon-list:before {\n  content: \"\\e937\";\n}\n.icon-more:before {\n  content: \"\\e938\";\n}\n.icon-bookmark:before {\n  content: \"\\e939\";\n}\n.icon-shelf:before {\n  content: \"\\e93a\";\n}\n.icon-idea:before {\n  content: \"\\e93b\";\n}\n.icon-recent:before {\n  content: \"\\e93c\";\n}\n.icon-sort:before {\n  content: \"\\e93d\";\n}\n.icon-search:before {\n  content: \"\\e93e\";\n}\n.icon-grid:before {\n  content: \"\\e93f\";\n}\n.icon-dropdown:before {\n  content: \"\\e940\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
